import axios from "axios";
import dayjs from "dayjs"

import { toast } from "react-toastify";

export const api = axios.create({
  baseURL: "https://mayadangayrimenkul.com.tr/api",
});

export const getAllProperties = async () => {
  try {
    const response = await api.get("/advertListAll", {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }

    const allProperties = response.data;

  
    return allProperties;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
};

export const getAllEmlakjetProperties = async () => {
  try {
    const response = await api.get("/advertListOfficeApi", {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }

    const allProperties = response.data;

  
    return allProperties;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
};


export const getAllCheapProperties = async () => {
  try {
    const response = await api.get("/cheapListOfficeApi", {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }

    const allPropertiesCheap = response.data;

  
    return allPropertiesCheap;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
};



export const getAllLinks= async () => {
  try {
    const response = await api.get("/links", {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }

    const allLinks = response.data;

  
    return allLinks;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
};


export const getMember = async (id) => {
  try {
    const response = await api.get(`/member/${id}`, {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
};

export const getProperty = async (id) => {
  try {
    const response = await api.get(`/advertDetail/${id}`, {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
};

/* export const getAllProperties = async () => {
  try {
    const response = await api.get("/residency/allresd", {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    toast.error("Something went wrong");
    throw error;
  }
}; */

export const createUser = async (email, token) => {
  try {
    await api.post(
      `/user/register`,
      { email },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    toast.error("Something went wrong, Please try again");
    throw error;
  }
};

export const bookVisit = async (date, propertyId, email, token) => {
  try {
    await api.post(
      `/user/bookVisit/${propertyId}`,
      {
        email,
        id: propertyId,
        date: dayjs(date).format("DD/MM/YYYY"),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    toast.error("Something went wrong, Please try again");
    throw error;
  }
};

export const removeBooking = async (id, email, token) => {
  try {
    await api.post(
      `/user/removeBooking/${id}`,
      {
        email,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    toast.error("Something went wrong, Please try again");

    throw error;
  }
};

export const toFav = async (id, email, token) => {
  try {
    await api.post(
      `/user/toFav/${id}`,
      {
        email,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (e) {
    throw e;
  }
};


export const getAllFav = async (email, token) => {
  if(!token) return 
  try{

    const res = await api.post(
      `/user/allFav`,
      {
        email,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
      
    return res.data["favResidenciesID"]

  }catch(e)
  {
    toast.error("Something went wrong while fetching favs");
    throw e
  }
} 


export const getAllBookings = async (email, token) => {
  
  if(!token) return 
  try {
    const res = await api.post(
      `/user/allBookings`,
      {
        email,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data["bookedVisits"];

    
  } catch (error) {
    toast.error("Something went wrong while fetching bookings");
    throw error
  }
}


export const createResidency = async (data, token) => {
  try{
    const res = await api.post(
      `/residency/create`,
      {
        data
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  }catch(error)
  {
    throw error
  }
}

// Blog API Functions
export const getAllBlogs = async () => {
  try {
    const response = await api.get("/blogs", {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }

    return response.data;
  } catch (error) {
    toast.error("Bloglar yüklenirken hata oluştu");
    throw error;
  }
};

export const getBlog = async (id) => {
  try {
    const response = await api.get(`/blogs/${id}`, {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    toast.error("Blog yüklenirken hata oluştu");
    throw error;
  }
};

export const getBlogComments = async (blogId) => {
  try {
    const response = await api.get(`/blogs/${blogId}/comments`, {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    toast.error("Yorumlar yüklenirken hata oluştu");
    throw error;
  }
};

export const createBlogComment = async (blogId, commentData) => {
  try {
    const response = await api.post(`/blogs/${blogId}/comment`, commentData, {
      timeout: 10 * 1000,
    });

    if (response.status === 400 || response.status === 500) {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    toast.error("Yorum gönderilirken hata oluştu");
    throw error;
  }
};